import "./hero.css";
import FormPopup from "../form/FormPopup";
import { useRef } from "react";

export default function Hero({ windowWidth }) {
  const dialogForm = useRef(null);
  const openDialog = () => dialogForm.current.showModal();
  const isMobile = windowWidth <= 1200;

  const contanctsHero = [
    {
      image: "/images/mailW.svg",
      link: "mailto:liderprava@ya.ru",
      name: "почта",
    },
    {
      image: "/images/phoneW.svg",
      link: "tel:+7 960 312 84 06",
      name: "телефон",
    },
    {
      image: "/images/whatsappW.svg",
      link: "https://api.whatsapp.com/send/?phone=79603128406&amp;text=Здравствуйте%21%0A%0AПишу+из+приложения+2ГИС.%0A%0A&amp;type=phone_number&amp;app_absent=0",
      name: "WhatsApp",
    },
    {
      image: "/images/vkW.svg",
      link: "https://vk.ru/im?sel=-239191554",
      name: "ВКонтакте",
    },
    {
      image: "/images/tgW.svg",
      link: "https://t.me/liderpravapfo?direct",
      name: "Телеграм",
    },
    {
      image: "/images/max.svg",
      link: "https://max.ru/join/KlnqqnrRDC6nN8p5G22IyKGhOCkcbRs-D830bo4qWQM",
      name: "Мессенджер Макс",
    },
  ];

  return (
    <div className="hero col" id="heroPage">
      <div className="hero-content col">
        <div className="col title-container">
          <h1 className="title fn org">Лидер права</h1>
          <h2 className="undertitle category">юридическая компания</h2>
        </div>
        <br />
        <span className="cath-phrase">Команда опытных профессионалов.</span>
        <br />
        <button
          className="buttonGen contact-hero-button row"
          onClick={openDialog}
        >
          <p>Бесплатная консультация</p>
          <img src={process.env.PUBLIC_URL + "/images/arrow.svg"} alt="arrow" />
        </button>
        <div className="row icons-container">
          {contanctsHero.map((item) => {
            if (item.name === "WhatsApp") return; // удалить в лучшие времена
            return (
              <a href={item.link} key={item.name} title={item.name}>
                <img
                  className="icon"
                  src={process.env.PUBLIC_URL + item.image}
                  alt={item.name}
                />
              </a>
            );
          })}
        </div>
      </div>
      <FormPopup ref={dialogForm} />
    </div>
  );
}
